export type DashboardPresetLayout = {
  cols: number;
  order: string[];
  widgetLocations?: Array<{
    id: string;
    sectionId: string | number;
    sectionIndex: number;
    index: number;
  }>;
  sectionColumns?: Record<string, string[][]>;
  widgets: Array<{ id: string; visible: boolean; size: 'full' | 'regular' | 'mini' | 'large' }>;
  favorites?: string[];
  openTradesColumns?: Record<string, boolean>;
  sections: Array<{
    id: string | number;
    title: string;
    isOpen: boolean;
    widgetIds: string[];
  }>;
};

import completePreset from './presets/complete.json';
import patternsPreset from './presets/patterns.json';
import performancePreset from './presets/performance.json';
import tradesPreset from './presets/trades.json';

const PERFORMANCE_PRESET = performancePreset as DashboardPresetLayout;
const TRADES_PRESET = tradesPreset as DashboardPresetLayout;
const PATTERNS_PRESET = patternsPreset as DashboardPresetLayout;
const COMPLETE_PRESET = completePreset as DashboardPresetLayout;

export const BUILT_IN_PRESET_LAYOUTS: Record<string, DashboardPresetLayout> = {
  performance: PERFORMANCE_PRESET,
  trades: TRADES_PRESET,
  patterns: PATTERNS_PRESET,
  complete: COMPLETE_PRESET,
};

export const BUILT_IN_PRESET_NAMES: Record<string, string> = {
  performance: 'Performance',
  trades: 'Trades',
  patterns: 'Patterns',
  complete: 'Complete',
};
